import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";

Font.register({
  family: "Manrope",
  fonts: [
    {
      src: "/fonts/Manrope-Regular.ttf", // Regular weight
      fontWeight: "normal",
    },
    {
      src: "/fonts/Manrope-Bold.ttf", // Bold weight
      fontWeight: "bold",
    },
    {
      src: "/fonts/Manrope-Medium.ttf", // Medium weight
      fontWeight: 500,
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Manrope",
  },
  headerSpace: {
    height: 80, 
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    marginBottom: 10,
  },
  headerRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 18,
    marginBottom: 18,
  },
  smallText: {
    fontSize: 9,
    color: "grey",
  },
  customerDetails: {
    marginTop: 8,
  },
  customerName: {
    fontSize: 11,
    fontWeight: "bold",
  },
  accountDetails: {
    textAlign: "center",
  },
  logo: {
    width: 70,
    height: 20,
    marginBottom: 8,
  },
  boldText: {
    // fontSize: 14,
    fontWeight: "bold",
    // marginBottom: 4,
    // textAlign: "center",
  },
  mainTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 4,
    textAlign: "center",
  },
  currencyDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "items-center",
    textAlign: "center",
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 2,
  },
  summaryBox: {
    paddingBottom: 8,
    borderBottom: "1px solid #ccc",
  },
  transactionRow: {
    flexDirection: "row",
    borderBottom: "1px solid #eee",
    // paddingVertical: 6,
  },
  tid: {
    fontSize: 9,
    fontWeight: "bold",
  },
  ref: {
    fontSize: 9,
    color: "grey",
  },
  cell: {
    fontSize: 10,
  },
  cellCredit: {
    color: "green",
    fontWeight: "bold",
  },
  cellDebit: {
    color: "red",
    fontWeight: "bold",
  },
  footerRow: {
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40,
    flexDirection: "row",
    justifyContent: "space-between",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
    paddingTop: 6,
  },
  footer: {
    fontSize: 9,
    color: "grey",
  },
  pageNumber: {
    fontSize: 9,
    color: "grey",
  },
});

const columnWidths = {
  BANK: 1.2,
  CHQDATE: 1.5,
  CHQNO: 1.2,
  CNAME: 2,
  DEPTNO: 1,
  JVTYPE: 1,
  PDC_ACC: 1.3,
  TR_SLNO: 1,
  TYPE_NO: 1,
  AMOUNT: 1,
};

const PDCReceivedDocument = ({
  pdcReceivedPrintDataFromAPI,
}) => {
  console.log("pdcReceivedPrintDataFromAPI:", pdcReceivedPrintDataFromAPI);

  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";



  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerSpace} fixed>
          {apiPaths_from_local_storage[0].REP_HEADER.includes("data:image/") ? (
            <Image
              src={apiPaths_from_local_storage[0].REP_HEADER}
              style={styles.header_image}
            />
          ) : null}
        </View>

        <Text style={styles.mainTitle}>PDC Received</Text>


        <View style={styles.headerRow}>
          <Text style={[styles.boldText, { flex: columnWidths.BANK }]}>
            BANK
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.CHQDATE }]}>
            CHQ DATE
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.CHQNO }]}>
            CHQ NO
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.CNAME }]}>
            C NAME
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.DEPTNO }]}>
            DEPT NO
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.JVTYPE }]}>
            JV TYPE
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.PDC_ACC }]}>
            PDC ACC
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.TR_SLNO }]}>
            TR SLNO
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.TYPE_NO }]}>
            TYPE NO
          </Text>
          <Text
            style={[
              styles.boldText,
              { flex: columnWidths.AMOUNT, textAlign: "right" },
            ]}
          >
            AMOUNT
          </Text>
        </View>

        {pdcReceivedPrintDataFromAPI?.map((t, i) => (
          <View key={i} style={styles.transactionRow}>
            <Text style={[styles.cell, { flex: columnWidths.BANK }]}>
              {t.BANK || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.CHQDATE }]}>
              {t.CHQDATE?.split("T")[0] || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.CHQNO }]}>
              {t.CHQNO || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.CNAME }]}>
              {t.CNAME || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.DEPTNO }]}>
              {t.DEPTNO || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.JVTYPE }]}>
              {t.JVTYPE || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.PDC_ACC }]}>
              {t.PDC_ACC || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.TR_SLNO }]}>
              {t.TR_SLNO || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.TYPE_NO }]}>
              {t.TYPE_NO || "-"}
            </Text>
            <Text
              style={[
                styles.cell,
                { flex: columnWidths.AMOUNT, textAlign: "right" },
              ]}
            >
              {t.AMOUNT ? Number(t.AMOUNT).toFixed(2) : "-"}
            </Text>
          </View>
        ))}

        <View style={styles.footerRow}>
          <Text
            style={styles.pageNumber}
            render={({ pageNumber }) => `Page ${pageNumber}`}
            fixed
          />
        </View>
      </Page>
    </Document>
  );
};

export default PDCReceivedDocument;
